import { createAsyncThunk } from "@reduxjs/toolkit";
import { LoginActions, LoginPersistActions } from "./LoginSlice";
// import { ChildrenStoreData, LoginStorageData, RootState } from "@parent-app/types";
// import { deRegisterFCMOnServer, validateSession } from "@parent-app/services";
// import { getLoginStoreData, isMobile } from "@parent-app/utils";
import { TimelineActions } from "../timeline/TimelineSlice";
import { deRegisterForFCM } from "../misc/push-notification/PushNotificationHandler";
import { ChildrenStoreData, LoginStorageData, NurseryGroupStoreData, RootState } from "src/shared/types/src";
import { getLoginStoreData, groupChildrenByNursery } from "src/shared/utils/src";
import { validateSession } from "src/shared/services/src";
import ProfileSlice, { profileAction } from "../profile/ProfileSlice";
import { nurserySettingAction } from "../nursery/NurserySlice";
import { MyWorldActions } from "../profile/myWorld/MyWorldSlice";
import { EyengageActions } from "../eyengage/EyengageSlice";
import { getNurserySettings } from "../nursery/NurseryHandler";
import { ConversationParticipantActions } from "../messages/conversations/participants/ConversationParticipantsSlice";
import { AccountAction } from "../account/AccountSlice";
import { calculateThemeColors } from "../misc/MiscHandler";

export const updateLoginStatus = createAsyncThunk(
    "updateLoginStatus", async ({ isLoggedIn }: { isLoggedIn: boolean }, { dispatch }) => {
        dispatch(LoginActions.setIsLoggedIn(isLoggedIn));
    }
);

export const updateLoginData = createAsyncThunk(
    "updateLoginData", async ({ loginData }: { loginData: LoginStorageData }, { dispatch }) => {
        dispatch(LoginPersistActions.setLoginData(loginData));
    }
)

export const updateChildrenGroupByNursery = createAsyncThunk(
    "updateChildrenGroupByNursery", async ({ data }: { data: NurseryGroupStoreData[] }, { dispatch }) => {
        dispatch(LoginPersistActions.setGroupedByNursery(data));
    }
)

export const updateCurrentChild = createAsyncThunk(
    "updateCurrentChild", async ({ currentChild }: { currentChild: ChildrenStoreData }, { dispatch, getState }) => {
        // set current nursery
        const nurseryData: NurseryGroupStoreData[] = (getState() as RootState).persistLogin.groupedByNursery;
        if (nurseryData && nurseryData.length > 0) {
            const nurseryOfCurrentChild = nurseryData.find((n) => n.nurseryInstanceKey === currentChild?.nursery?.nurseryInstanceKey);
            if (nurseryOfCurrentChild) {
                await dispatch(updateCurrentNursery({ nurseryOfCurrentChild }));
            }
        }

        // reset the states which are dependent on current child selection
        await dispatch(resetStatesOnChildChange());
        await dispatch(LoginPersistActions.setCurrentChild(currentChild));
        // fetch new settings for current child
        await dispatch(getNurserySettings({ child: currentChild }));
        // reset the current nursery
        // await dispatch(updateCurrentNursery({ nurseryOfCurrentChild: {} as NurseryGroupStoreData }));
    }
)

export const updateCurrentNursery = createAsyncThunk(
    "updateCurrentNursery", async ({ nurseryOfCurrentChild }: { nurseryOfCurrentChild: NurseryGroupStoreData }, { dispatch }) => {
        // reset the states which are dependent on current nursery selection
        await dispatch(resetStatesOnNurseryChange());
        // calculate the branding colors and save to the store
        await dispatch(calculateThemeColors({ brandColor: nurseryOfCurrentChild?.brandingColor }));

        // set current nursery
        await dispatch(LoginPersistActions.setCurrentNursery(nurseryOfCurrentChild));
    }
)

// export const updateCurrentNursery = createAsyncThunk(
//     "updateCurrentNursery", async ({ currentNursery }: { currentNursery : NurseryGroupStoreData} , { dispatch }) => {
//         // reset the states which are dependent on current child selection
//         await dispatch(resetStatesOnChildChange());
//         await dispatch(LoginPersistActions.setCurrentChild(currentChild));
//         // set current nursery
//         const nurseryData: NurseryGroupStoreData[] = (reduxStore.getState() as RootState).persistLogin.groupedByNursery;
//         if (nurseryData && nurseryData.length > 0) {
//             const nurseryOfCurrentChild = nurseryData.find((n) => n.id === currentChild?.nursery?.id);
//             if (nurseryOfCurrentChild) {
//                 await dispatch(LoginPersistActions.setCurrentNursery(nurseryOfCurrentChild));
//             }
//         }
//     }
// )

export const resetStatesOnChildChange = createAsyncThunk(
    "resetStatesOnChildChange", async (_, { dispatch }) => {
        // reset the states
        await dispatch(nurserySettingAction.resetNurserySettings());
        await dispatch(TimelineActions.resetTimelineAndFilters());
        await dispatch(profileAction.resetProfile());
        await dispatch(MyWorldActions.resetMyWorldState());
        await dispatch(AccountAction.resetAccountOnChildChange());
    }
)

export const resetStatesOnNurseryChange = createAsyncThunk(
    "resetStatesOnNurseryChange", async (_, { dispatch }) => {
        // reset the states
        await dispatch(EyengageActions.resetEyengageState());
        // await dispatch(ConversationActions.resetConversationState());
        // await dispatch(CommunicationActions.resetCommunicationState());
        // await dispatch(InboxActions.resetInboxState());
        // await dispatch(SentBoxActions.resetSentBoxState());
        await dispatch(ConversationParticipantActions.resetConversationParticipantState(null));
    }
)

export const performAfterLogin = createAsyncThunk(
    "performAfterLogin", async ({ dataToStore, reduxStore }: { dataToStore: LoginStorageData, reduxStore: any }, { dispatch }) => {
        try {
            await dispatch(updateLoginData({ loginData: dataToStore }));
            const groupByNursery = groupChildrenByNursery(dataToStore.children);
            await dispatch(updateChildrenGroupByNursery({ data: groupByNursery }));
            const currentChild: ChildrenStoreData = (reduxStore.getState() as RootState).persistLogin.currentChild;
            let updatedChild: ChildrenStoreData = {} as ChildrenStoreData;
            if (!currentChild || Object.keys(currentChild).length === 0) {
                updatedChild = dataToStore.children[0];
            } else {
                const childData = dataToStore.children.find((child) => (child.childInstanceKey === currentChild.childInstanceKey));
                console.log("childData : ", childData);
                if (!childData) {
                    updatedChild = dataToStore.children.find((child) => child.active) || dataToStore.children[0];
                } else {
                    updatedChild = childData;
                }
            }
            await dispatch(updateCurrentChild({ currentChild: updatedChild }));
            if (dataToStore.accessToken && dataToStore.refreshToken)
                await dispatch(updateLoginStatus({ isLoggedIn: true }));
        } catch (error) {
            console.log("error in performAfterLogin : ", error);
        }
    }
)

export const validateLoginTokens = createAsyncThunk(
    "validateLoginTokens", async ({ reduxStore }: { reduxStore: any }, { dispatch }) => {
        try {
            const loginState = (reduxStore.getState() as RootState).persistLogin.loginData;
            await dispatch(LoginActions.setAuthLoading(true));
            const response = await validateSession({ refreshToken: loginState.refreshToken });
            console.log("response from auth call in handler : ", response);
            if (response && Object.keys(response).length) {
                const dataToStore: LoginStorageData | undefined = getLoginStoreData(response);
                if (dataToStore) {
                    await dispatch(performAfterLogin({ dataToStore, reduxStore }));
                    return true;
                }
            }
            return false;
        } catch (error: any) {
            console.log("error in validateLoginTokens : ", error);
            if (error && (error?.message === 'Network Error' || error?.code === 'ECONNABORTED')) {
                return true;
            }
            return false;
        } finally {
            await dispatch(LoginActions.setAuthLoading(false));
        }
    }
)

export const logout = createAsyncThunk(
    "logout", async ({ reduxStore, deviceId, platform }: { reduxStore: any, platform?: string, deviceId?: string }, { dispatch }) => {
        try {
            await dispatch(LoginActions.setAuthLoading(true));
            // de-register FCM
            if (platform) {
                console.log("calling api");
                await dispatch(deRegisterForFCM({ platform }));
            }
            await dispatch(LoginActions.resetLoginState());
            await dispatch(LoginPersistActions.resetPersistLoginState());
            // await dispatch(LoginPersistActions.setCurrentChild({} as ChildrenStoreData));
            // reset all states to initial state
            await dispatch({ type: 'RESET_APP' });
            await dispatch(LoginActions.setIsLoggedIn(false));
            // return Promise.resolve(true);
        } catch (error) {
            console.log("error in logout : ", error, (error as any).response);
            // return Promise.resolve(false);
        } finally {
            await dispatch(LoginActions.setAuthLoading(false));
        }
    }
)